import { create } from 'zustand';

const useViewerStore = create<{
  showAllMeta: boolean;
  setShowAllMeta: (showAllMeta: boolean) => void;
}>((set) => ({
  showAllMeta: false,
  setShowAllMeta: (showAllMeta) => set({ showAllMeta }),
}));

export default useViewerStore;
